import { TApplicationState } from '../../types/redux';

export const selectFormLastAttemptTimestamp = (state: TApplicationState) =>
  state.requestFormV2.phoneVerification.lastAttemptTimestamp;
